import { Component } from '@angular/core';

@Component({
  selector: 'app-alert',
  templateUrl: './alert-banner.component.html',
  styleUrls: ['./alert-banner.component.scss']
})
export class AlertBannerComponent {
  active: boolean = false;
}
